<div class="main-content" *ngIf="_userRoles != null">
  <div class="container-fluid">
      <div class="card sq-card">
          <div class="card-header card-header-squirrel">
              <div>
                  <h4>API Token</h4>             
              </div>
              <div class="clearfix"></div>
          </div>
          <div class="card-body">
            <!-- <div class="card-body" *ngIf="_userRoles.includes('MANAGE_PROJECTS') || _userRoles.includes('admin')"> -->
              <div class="row">
                  <div class="col-md-8">
                    <a>
                      <!-- <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 5px" matTooltip="{{this.translate.data['ADDNEWPROJECT'] | translate}}"
                          (click)="addOwnToken()" [hidden]="!(_userRoles.includes('CREATE_APITOKEN'))">Neuer API Token (own)
                      </button> -->
                      <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 5px" matTooltip="Neues Api Token erstellen"
                          (click)="addApiToken()" >Neues API Token
                      </button>
                    </a>                   
                  </div>
                  <!-- <div class="col-md-8">
                      <mat-slide-toggle  [disabled]="false" color="primary" (change)="onChange()">archivierte Projekte</mat-slide-toggle> 
                  </div> -->
        
              </div>
              <div class="row">
                  <div class="col-md-12 tenant-grouproles-board-body-table">
                      <div class="token-board-body-table" style="overflow: auto;">
                          <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                          <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                          <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                              Squirrel's API rate limit has been reached. It will be reset in one minute.
                          </div>
                      </div>
                      <ag-grid-angular class="ag-theme-balham" style="width:100%; height: 98%; padding: 5px;"
                          [overlayLoadingTemplate]="overlayLoadingTemplate"
                          [gridOptions]="gridOptions"
                          (gridReady)="onGridReady($event)" 
                          [components]="components"
                          >
                      </ag-grid-angular>                    
                  </div>
              </div>               
          </div>               
      </div>
  </div>
</div>

